import { render } from "./LandIncidentsTable.vue?vue&type=template&id=d4ac4f50&scoped=true&ts=true"
import script from "./LandIncidentsTable.vue?vue&type=script&lang=ts"
export * from "./LandIncidentsTable.vue?vue&type=script&lang=ts"

import "./LandIncidentsTable.vue?vue&type=style&index=0&id=d4ac4f50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4ac4f50"]])

export default __exports__